import Phaser from 'phaser';
import { costumeTint, PLAYER_NAME_MIN, PLAYER_NAME_MAX } from '@ponponland/shared';
import { mountRoot } from '../ui/dom.js';
import { logoHtml, ponBlobHtml, starfieldHtml } from '../ui/blob.js';
import { session } from '../state/session.js';
import { rememberPlayer } from '../state/persist.js';

/**
 * Splash / "come in" screen — faithful to the prototype `SplashScreen`
 * (`docs/design/flow/screens1.jsx`): centered hero (logo + happy blob) beside a
 * parchment card to name your jelly, then "Enter PonPonLand →" advances to the
 * Room Browser. The Enter button is disabled until the name is >= 2 chars
 * (mirrors the prototype's `valid`).
 */
export class SplashScene extends Phaser.Scene {
  constructor() {
    super('Splash');
  }

  create(): void {
    const player = session.player;
    const tint = costumeTint(player.costume);

    const root = mountRoot(
      this,
      `<div class="scene fade-in" style="justify-content:center;align-items:center;padding:24px">
        ${starfieldHtml(34)}
        <div style="display:flex;align-items:center;gap:44px;z-index:2">
          <div style="display:flex;flex-direction:column;align-items:center;gap:14px">
            ${logoHtml(1.15)}
            <div style="margin-top:6px">${ponBlobHtml({ colour: tint, costume: player.costume, size: 132, eyes: 'happy', idle: true })}</div>
          </div>
          <div class="panel" style="width:344px;padding:20px 22px;display:flex;flex-direction:column;gap:14px;z-index:2">
            <div>
              <div style="font-size:20px;font-weight:700;margin-bottom:2px">Welcome, Pon Pon!</div>
              <div class="muted" style="font-size:13px">Name your jelly to begin — your colour changes as you absorb elements in-game.</div>
            </div>
            <div>
              <label class="lab">Your name</label>
              <input class="field" id="pp-name" maxlength="${PLAYER_NAME_MAX}" placeholder="e.g. Jelly" />
            </div>
            <button class="btn lg block" id="pp-enter" style="width:100%">Enter PonPonLand →</button>
          </div>
        </div>
      </div>`
    );

    const nameInput = root.querySelector<HTMLInputElement>('#pp-name')!;
    const enterBtn = root.querySelector<HTMLButtonElement>('#pp-enter')!;
    nameInput.value = player.name;

    const isValid = (): boolean => nameInput.value.trim().length >= PLAYER_NAME_MIN;
    const refresh = (): void => {
      enterBtn.disabled = !isValid();
    };

    const enter = (): void => {
      if (!isValid()) return;
      session.player = { name: nameInput.value.trim(), costume: player.costume };
      rememberPlayer(); // remember the identity for next visit
      this.scene.start('RoomBrowser');
    };

    refresh();
    nameInput.addEventListener('input', refresh);
    nameInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') enter();
    });
    enterBtn.addEventListener('click', enter);
  }
}
